import { useContext, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {
  PricingSheet,
  PricingSheetRow,
} from '../../../../../shared/types';

import NotificationProvider from '../../../providers/Notification/NotificationProvider';
import { createNewVersionById } from '../../../services/pricingSheets';
import Dates from '../../../components/Steps/Components/Dates';
import { Box } from '@mui/system';
import { HandleDateChange } from '../../../components/Steps/InitialInformationStep';
import { setDatetoStartOfUTCDay } from '../../../utils/formatDateTimes';

export interface RenewPricingSheetDialogProps {
  pricingSheet: PricingSheet;
  open: boolean;
  title: string;
  hierarchy: PricingSheetRow[];
  onClose: () => void;
  goToEditPricingSheet: (pricingSheetId: string) => void;
}
const RenewPricingSheetDialog = (
  props: RenewPricingSheetDialogProps,
) => {
  const { pricingSheet, open, title, onClose, goToEditPricingSheet } =
    props;
  const { setNotification } = useContext(NotificationProvider);
  const [startDate, setStartDate] = useState(
    setDatetoStartOfUTCDay(new Date()),
  );
  const [endDate, setEndDate] = useState(
    setDatetoStartOfUTCDay(new Date()),
  );

  const handleStartDateChange: HandleDateChange = (
    value: Date | null,
  ) => {
    if (value) {
      setStartDate(setDatetoStartOfUTCDay(value));
    }
  };

  const handleEndDateChange: HandleDateChange = (
    value: Date | null,
  ) => {
    if (value) {
      setEndDate(setDatetoStartOfUTCDay(value));
    }
  };
  const onClickCreateNewSheetVersion = async (
    pricingSheet: PricingSheet,
  ) => {
    try {
      const newPricingSheet: any = await createNewVersionById(
        pricingSheet.id,
        startDate,
        endDate,
      );
      goToEditPricingSheet(newPricingSheet.id);
      setNotification({
        type: 'SNACKBAR',
        duration: 3000,
        severity: 'success',
        message: `Hinnasto ${newPricingSheet.name} luotu luonnostilassa!`,
      });
    } catch (error) {
      setNotification({
        type: 'SNACKBAR',
        duration: 3000,
        severity: 'error',
        message: `Palvelimella tapahtui virhe! Uuden version luonti hinnastosta epäonnistui!`,
      });
    }
  };

  return (
    <Dialog disableScrollLock open={open} onClose={onClose}>
      <DialogTitle id="new-version-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          {pricingSheet.name}
        </DialogContentText>

        <DialogContentText>
          Olet jatkamassa hinnaston voimassaoloaikaa. Hinnastosta
          luodaan uusi versio samoilla tiedoilla ja tuotteilla kuin
          edellinen,
          <b> mutta ehdotushinnat ovat saattaneet muuttua.</b>
          <br />
          Hinnasto saattaa vaatia uuden hyväksynnän.
        </DialogContentText>
        <Box sx={{ mt: 4 }}>
          <Dates
            onStartDateChange={handleStartDateChange}
            onEndDateChange={handleEndDateChange}
            minStartDate={new Date()}
            startDate={startDate}
            endDate={endDate}
            startDateLabel={'Hinnasto voimassa alkaen'}
            endDateLabel={'Hinnaston päättymispäivä'}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button color="inherit" onClick={onClose}>
          Peruuta
        </Button>
        <Button
          onClick={() => onClickCreateNewSheetVersion(pricingSheet)}
          autoFocus
        >
          Jatka
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RenewPricingSheetDialog;
